import { Box, Typography } from "@mui/joy";
import { motion } from "framer-motion";
import { Section, Container, COLORS } from "../shared/ui";

// Логотипы клиентов. Тексты — пока как заглушки;
// при реальной интеграции заменить на <img src="/logos/burger-king.svg" />
const CLIENTS = [
  { name: "Burger King",      color: "#D62300", logo: "./burger-king.png" },
  { name: "Rostic's",          color: "#E4002B", logo: "./rostics.png" },
  { name: "Живика",            color: "#F5A623", logo: "./jivika.png" },
  { name: "Жизньмарт",         color: "#1E8449", logo: "./jisn_mart.webp" },
  { name: "Kaifa",             color: "rgb(221, 5, 5)", logo: "./kaifa.png" },
  { name: "Счастливый Взгляд", color: "#00A859", logo: "./schas_vzgl.png" },
  { name: "Улыбка Радуги",     color: "#E91E63", logo: "./ulibka_radugi.png" },
  // { name: "Экспресс Дизайн",   color: "#00AEEF", logo: "./express_disain.png" },
];

// Дублируем массив для бесшовного marquee
const DOUBLED = [...CLIENTS, ...CLIENTS];

export default function LogoStrip() {
  return (
    <Section id="logos" py={{ xs: 6, md: 8 }} sx={{ background: COLORS.bgLight }}>
      <Container>
        <Box sx={{ textAlign: "center", mb: 5 }}>
          <Typography
            level="body-xs"
            sx={{
              textTransform: "uppercase",
              letterSpacing: "0.16em",
              fontWeight: 700,
              color: COLORS.brand,
              mb: 1,
            }}
          >
            Нам доверяют федеральные сети
          </Typography>
          <Typography
            level="h3"
            sx={{
              fontWeight: 800,
              color: COLORS.dark,
              fontSize: { xs: "1.4rem", md: "1.75rem" },
              letterSpacing: "-0.5px",
            }}
          >
            2 400+ замеренных объектов для 50+ компаний
          </Typography>
        </Box>
      </Container>

      {/* Marquee-лента */}
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          maskImage: "linear-gradient(to right, transparent, #000 10%, #000 90%, transparent)",
          WebkitMaskImage: "linear-gradient(to right, transparent, #000 10%, #000 90%, transparent)",
        }}
      >
        <motion.div
          animate={{ x: ["0%", "-50%"] }}
          transition={{ repeat: Infinity, duration: 40, ease: "linear" }}
          style={{ display: "flex", gap: 48, width: "max-content", alignItems: "center", paddingBlock: 16 }}
        >
          {DOUBLED.map((client, i) => (
            <LogoPlaceholder key={i} client={client} />
          ))}
        </motion.div>
      </Box>
    </Section>
  );
}

function LogoPlaceholder({ client }) {
  return (
    <Box
      sx={{
        flexShrink: 0,
        height: 64,
        px: 3.5,
        borderRadius: "14px",
        background: "#fff",
        border: "1px solid rgba(99,102,241,0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 16px rgba(99,102,241,0.06)",
        filter: "grayscale(1)",
        opacity: 0.7,
        transition: "all 0.3s ease",
        cursor: "default",
        "&:hover": {
          filter: "grayscale(0)",
          opacity: 1,
          transform: "scale(1.05)",
          boxShadow: "0 8px 24px rgba(99,102,241,0.12)",
        },
      }}
    >
      {/* <Typography
        sx={{
          fontWeight: 800,
          fontSize: "1.1rem",
          color: client.color,
          letterSpacing: "-0.5px",
          whiteSpace: "nowrap",
        }}
      >
        {client.name}
      </Typography> */}
      <Box
        component={'img'}
        src={client.logo}
        sx={{
          width: 100,
          fontSize: "1.1rem",
          color: client.color,
          letterSpacing: "-0.5px",
          whiteSpace: "nowrap",
        }}
      />
    </Box>
  );
}